import { Pipe, PipeTransform } from '@angular/core';
import { Column } from '@miq/catalog';

/**
 * This pipe returns the "collapsable" and  related  column list to a given column.
 * When targetRelationType is given it returns only those columns of given relationType
 */
@Pipe({
  name: 'relatedConfigs',
  standalone: false,
})
export class RelatedInputConfigPipe implements PipeTransform {
  /**
   * Returns all or given relation type related columns of given column
   * @param column
   * @param targetRelationType
   * @returns
   */
  transform(column: Column, targetRelationType: string = null): Column[] {
    return column?.getRelatedColumns(targetRelationType);
  }
}
